import React, { Component } from "react";

import i18n from "i18n-react";
import { HashLink as Link } from "react-router-hash-link";

import { name, storageKeys } from "settings";
import { BackImage, StorageHandler, LanguageSelect } from "C4";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class WelcomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logo: null,
    };
  }

  componentDidMount() {
    const savedRoute = localStorage.getItem("savedRoute");
    if (
      savedRoute !== null &&
      savedRoute !== "undefined" &&
      savedRoute !== "/login" &&
      savedRoute !== "/logout" &&
      savedRoute !== "/register" &&
      savedRoute !== "/sso"
    ) {
      setTimeout(() => {
        window.location.href = savedRoute; // Redirect to the saved route
      }, 5000);
    } else {
      setTimeout(() => {
        window.location.href = "/main";
      }, 5000);
    }

    this.getAppInfo();
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logo,
      });
    }
  }

  render() {
    const { logo } = this.state;
    return (
      <div className="magicLinkView">
        <div className="sso-bg" />
        <div className="sso-content">
          {logo && <img src={logo} className="logo" alt="Logo" />}
          <span className="spinner">
            <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
          </span>
        </div>
      </div>
    );
  }
}
